import { forwardRef } from "react";

import { ButtonProps as AntdButtonProps } from "antd";

import { StyledButton } from "./styles";

type ButtonProps = Omit<AntdButtonProps, "type"> & {
  type?: AntdButtonProps["type"] | "gradient";
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ type, ...props }, ref) => {
    return (
      <StyledButton
        ref={ref}
        {...props}
        type={type === "gradient" ? "primary" : type}
        $gradient={type === "gradient"}
      />
    );
  },
);

Button.displayName = "Button";

export default Button;
